module.exports = __webpack_public_path__ + "static/media/148.cc1b5e01.png";